/**
 * Parses Google Docs/Sheets/Slides/Drive URLs and extracts the document ID
 * and inferred MIME type.
 */

export interface DriveUrlInfo {
  docId: string;
  mimeType: string;
}

const DRIVE_URL_PATTERNS: {
  pattern: RegExp;
  mimeType: string;
}[] = [
  {
    pattern: /docs\.google\.com\/document\/d\/([a-zA-Z0-9_-]+)/,
    mimeType: 'application/vnd.google-apps.document',
  },
  {
    pattern: /docs\.google\.com\/spreadsheets\/d\/([a-zA-Z0-9_-]+)/,
    mimeType: 'application/vnd.google-apps.spreadsheet',
  },
  {
    pattern: /docs\.google\.com\/presentation\/d\/([a-zA-Z0-9_-]+)/,
    mimeType: 'application/vnd.google-apps.presentation',
  },
  {
    pattern: /drive\.google\.com\/file\/d\/([a-zA-Z0-9_-]+)/,
    mimeType: 'unknown',
  },
];

export function parseDriveUrl(url: string): DriveUrlInfo | null {
  if (!url) return null;

  for (const { pattern, mimeType } of DRIVE_URL_PATTERNS) {
    const match = url.match(pattern);
    if (match?.[1]) {
      return { docId: match[1], mimeType };
    }
  }

  return null;
}

export function isDriveUrl(url: string): boolean {
  return parseDriveUrl(url) !== null;
}
